<svelte:options />

<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import FloatingMenu from '#floating-menu/FloatingMenu.svelte';
    import { floatingMenuRowTypes } from '@repo/config/Global';
    import { UID } from '@repo/config/Utils';
    /**
     * @typedef {Object} Props
     * @property {any} name
     * @property {any} [value]
     * @property {any} [options]
     * @property {boolean} [required] - eslint-disable-line no-unused-vars
     * @property {any} associatedID
     * @property {any} [legend]
     * @property {any} [labelBy]
     */
    let {
        name,
        value = $bindable([]),
        options = [],
        required = false,
        associatedID = null,
        legend = null,
        labelBy = null,
        disabled = false,
    } = $props();

    const dispatch = createEventDispatcher();
    
    const id = UID();
    let me = $state(null);
    let menu = $state(null);

    let isShowMenu = $state(false);
    let menuTop = $state('0px');
    let menuLeft = $state('0px');

    // Guard against non-array values
    let selected = $derived(Array.isArray(value) ? value : []);

    let selectedCount = $derived.by(() => {
        let count = 0;
        options.forEach((o) => {
            if (selected.indexOf(o.name) > -1) count++;
        });

        return count;
    });
    let optionsMenuItems = $derived.by(() => {
        const _optionsMenuItems = [];
        if (legend) {
            _optionsMenuItems.push({
                label: legend,
                type: floatingMenuRowTypes.SECTION_TITLE,
            });
        }
        options.forEach((o) => {
            const item = {
                label: o.displayName,
                name: `_${o.displayName}`,
                action: o.name,
                type: floatingMenuRowTypes.CHECK_BOX,
                checked: selected.indexOf(o.name) > -1,
            };

            if ('disabled' in o) item.disabled = o.disabled;

            _optionsMenuItems.push(item);
        });

        return _optionsMenuItems;
    });

    function handleMenuClick(e) {
        if (!Array.isArray(value)) value = [];

        if (e.detail.action.state) {
            if (value.indexOf(e.detail.action.id) < 0)
                value.push(e.detail.action.id);
        } else {
            if (value.indexOf(e.detail.action.id) > -1)
                value.splice(value.indexOf(e.detail.action.id), 1);
        }

        value = me.value = value.concat();

        dispatch('change', {
            originalEvent: e,
            name,
            value,
            associatedID,
        });
    }

    function toggleMenu(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (optionsMenuItems.length > 0) {
            isShowMenu = !isShowMenu;
            if (isShowMenu) {
                const b = me.getBoundingClientRect();
                menuLeft = b.left + 'px';
                menuTop = b.bottom + 3 + 'px';
            }
        }
    }

    onMount(() => {
        me.value = value;
    });

    export {
        name,
        value,
        options,
        required,
        associatedID,
        legend,
        labelBy,
    };
</script>

<div {id} bind:this={me} class="input select-group" {name}>
    <button
        onclick={toggleMenu}
        class="select row interactive"
        role="combobox"
        aria-haspopup="listbox"
        aria-labelledby={labelBy}
        aria-expanded={isShowMenu}
        aria-controls={`select-group-${id}`}
        {disabled}
    >
        {#if disabled }
            <span>0 Selected</span>
        {:else if optionsMenuItems.length > 0}
            {#key value}
                <span>{selectedCount + ' Selected'}</span>
            {/key}
            <i class="material-icons" aria-hidden="true">expand_more</i>
        {:else}
            <img src="/ui/loader.svg" alt="loading..." />
        {/if}
    </button>
    {#if isShowMenu}
        <FloatingMenu
            bind:this={menu}
            on:click={handleMenuClick}
            close={() => (isShowMenu = false)}
            items={optionsMenuItems}
            top={menuTop}
            left={menuLeft}
            as="ul"
            ariaCheckboxGroup={true}
            ariaListBox={true}
            noAriaRole={true}
            id={`select-group-${id}`}
        />
    {/if}
</div>

<style>
    .input {
        display: flex;
    }

    .row {
        display: flex;
        align-items: center;
    }

    .row > img {
        width: 1.5rem;
    }

    .select {
        padding: 0.5rem 0.5rem 0.5rem 0.75rem;
        border-radius: 0.25rem;
        background-color: rgba(255, 255, 255, 0.2);
        color: white;
        width: 100%;
        justify-content: space-between;
    }

    .select:hover {
        background-color: rgba(255, 255, 255, 0.3);
    }

    .select span {
        margin-right: 0.5rem;
    }
</style>
